import elementsType = stripe.elements.Elements;
import Element = stripe.elements.Element;
import { PaymentResponse } from '@/interfaces/PaymentResponse';

export class PaymentService {
    public static initializePaypal(element: HTMLElement,
                                   billingAddressId: number,
                                   totalPrice: string,
                                   callback: (orderId: string, billingAddressId: number) =>
                                       void) {
        while (element.firstChild) {
            try {
                element.removeChild(element.firstChild);
            } catch (err) {
                console.error(err);
            }
        }

        // @ts-ignore
        paypal.Buttons({
            createOrder(data: object, actions:
                {
                    order: {
                        create: (payload: { intent: string, purchase_units: object[] }) => object,
                    },
                }) {
                return actions.order.create({
                    intent: 'CAPTURE',
                    purchase_units: [{
                        amount: {
                            value: totalPrice,
                        },
                    }],
                });

            },
            async onApprove(data: { orderID: string }) {
                await callback(data.orderID, billingAddressId);
            },
        }).render('#paypal-button-container');
    }

    // @ts-ignore
    private stripe: stripe.Stripe;
    private elements!: elementsType;
    private card: Element | undefined;

    // public constructor(key: string) {
    //     this.stripe = Stripe(key);
    //     this.elements = this.stripe.elements();
    // }

    public constructor() {}

    public mount(element: HTMLElement) {
        if (this.card === undefined) {

            this.card = this.elements.create('card');
        }
        this.card.mount(element);
    }

    public async createPaymentMethod() {
        if (this.card === undefined) {
            throw new Error('Card element is empty');
        }
        return await this.stripe.createPaymentMethod('card', this.card);
    }

    public async handleCardAction(clientSecret: string) {
        if (this.card === undefined) {
            throw new Error('Card element is empty');
        }
        return await this.stripe.handleCardAction(clientSecret);
    }

    public shouldHandle3DPayment(paymentResponse: PaymentResponse, paymentMethod: string) {
        return paymentMethod === 'stripe' && paymentResponse.data.attributes.requires_action;
    }

}
